import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZuperShimmerLoadingComponent } from './zuper-shimmer-loading.component';

@NgModule({
  declarations: [ZuperShimmerLoadingComponent],
  imports: [CommonModule],
  exports: [ZuperShimmerLoadingComponent]
})
export class ZuperShimmerLoadingModule {}
